import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {NodeConfigurationType} from '../Models/enum/nodeConfigurationType';

@Injectable({
  providedIn: 'root'
})
export class BatchService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getAllBatchTemplates() {
    return this.http.get<any[]>('api/batch/getAllBatchTemplates');
  }

  deleteBatchTemplate(batchTemplateId: number) {
    return this.http.delete(`api/batch/deleteBatchTemplate/${batchTemplateId}`);
  }

  searchPagedBatchSubmission(filter: any) {
    return this.http.post<any>('api/batch/searchPagedBatchSubmission', filter);
  }

  cancelSubmission(batchSubmissionId: number) {
    return this.http.get<void>(`api/batch/cancelSubmission/${batchSubmissionId}`);
  }

  continueBatchSubmission(batchSubmissionId: number) {
    return this.http.get<void>(`api/batch/continueBatchSubmission/${batchSubmissionId}`);
  }

  finishBatchSubmission(batchSubmissionId: number) {
    return this.http.get<void>(`api/batch/finishBatchSubmission/${batchSubmissionId}`);
  }

  pauseBatchSubmission(batchSubmissionId: number) {
    return this.http.get<void>(`api/batch/pauseBatchSubmission/${batchSubmissionId}`);
  }

  getErrorBatchItems(batchSubmissionId: number) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/download');
    return this.http.get(`api/batch/getErrorBatchSubmissionItems/${batchSubmissionId}`,
      { headers: headers, responseType: 'blob' });
  }

  createBatchTemplate(batchTemplate: any) {
    return this.http.post<number>('api/batch/createBatchTemplate', batchTemplate);
  }

  updateBatchTemplate(batchTemplate: any) {
    return this.http.put('api/batch/updateBatchTemplate', batchTemplate);
  }

  getUsersByBatchTemplateBusinessProcess(batchTemplateId: number) {
    return this.http.get<any[]>(`api/batch/getUsersByBatchTemplateBusinessProcess/${batchTemplateId}`);
  }

  getStatesByPublishedBusinessProcess(businesProcessId: number) {
    return this.http.get<any[]>(`api/batch/getStatesByPublishedBusinessProcess/${businesProcessId}`);
  }

  getAllConfigurationNodesByType(nodeConfigurationType: NodeConfigurationType) {
    return this.http.get<any[]>(`api/batch/getAllConfigurationNodesByType/${nodeConfigurationType}`);
  }

  getBusinessProcessesForStartByUser(userLogon: string) {
    return this.http.get<any[]>(`api/batch/getBusinessProcessesForStartByUser/${userLogon}`);
  }

  submitBatch(submission: any, uploadSession) {
    return this.http.post<any>('api/batch/submitBatch', { submission: submission, uploadSession });
  }
}
